import React from "react";
import { Space, Select, Form, Button, InputNumber } from "antd";
import { useTranslation } from "react-i18next";

import "../../../public/sass/components/_filters.scss";

// const { Search } = Input;
const { Option } = Select;

export const Filters = ({
  onSearch,
  handleFilter,
  handleGetAllCompanies,
  search,
  setSearch,
}) => {
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();

  const clearFilters = () => {
    form.resetFields();
    handleGetAllCompanies();
    setSearch(false);
  };

  // return null;
  return (
    <div className="wrapper">
      <Space direction="horizontal" className="filters">
        <Form
          form={form}
          id="companies-filters"
          layout="inline"
          scrollToFirstError
          onFinish={handleFilter}
        >
          {/* <Form.Item name="user_quantity">
            <InputNumber
              className="min-width-select-component"
              type="number"
              placeholder={t("user_qty")}
            />
          </Form.Item> */}
          <Form.Item name="status">
            <Select
              name="status"
              showSearch={true}
              searchBy="label"
              optionFilterProp="children"
              placeholder="Status"
              className="min-width-select-component"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) === 0
              }
            >
              <Option value={1}>{t("active")}</Option>
              <Option value={0}>{t("not_active")}</Option>
            </Select>
          </Form.Item>

          <Button
            type="primary"
            form="companies-filters"
            key="submit"
            htmlType="submit"
          >
            Filter
          </Button>
          {search && (
            <Button onClick={clearFilters} className="button-style">
              {t("clear_filter")}
            </Button>
          )}
        </Form>
      </Space>
    </div>
  );
};
